// import * as firebase from 'firebase/app';
// import 'firebase/auth';
// import VueAnalytics from 'vue-analytics';

import Vue from "vue";
import App from "@/App.vue";
import { sync } from "vuex-router-sync";

import router from "@/routes";
import store from "@/store";

import number from "@/filters/numbers";
import FirebaseAuthPlugin from "@/firebase";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import Buefy from "buefy";
import "buefy/dist/buefy.css";

import VTooltip from "v-tooltip";
import VueApexCharts from "vue-apexcharts";

Vue.config.productionTip = false;

Vue.use(FirebaseAuthPlugin);
Vue.use(number);
Vue.use(Buefy);
Vue.use(VTooltip);
Vue.use(VueSweetalert2);
Vue.use(VueApexCharts);

// Vue.use(VueAnalytics, {
//   id: 'UA-12064266-1',
//   router,
//   autoTracking: {
//     exception: true
//   }
// });
// const config = {
//   apiKey: "AIzaSyC-IfZxvHhtOL8W5Iqfyr8cvUVNJw1AM3o",
//   authDomain: "yungol.firebaseapp.com",
//   databaseURL: "https://yungol.firebaseio.com",
//   projectId: "yungol",
//   storageBucket: "yungol.appspot.com",
//   messagingSenderId: "832818798890",
//   appId: "1:832818798890:web:626640064fd06e45"
// };

// firebase.initializeApp(config);

Vue.component("apexchart", VueApexCharts);
sync(store, router);

new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  store,
});

// let app;

// firebase.auth().onAuthStateChanged(() => {
//   if (!app) {
//     app = new Vue({
//       el: '#app',
//       render: h => h(App),
//       router,
//       store
//     });
//   }
// });



// WEBPACK FOOTER //
// ./src/main.js